import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20interior%20with%20red%20velvet%20curtains%20and%20warm%20stage%20lighting%2C%20elegant%20movie%20theater%20atmosphere%2C%20dramatic%20shadows%2C%20luxurious%20gold%20accents%2C%20professional%20cinema%20photography%2C%20rich%20dark%20tones%20with%20warm%20highlights&width=1800&height=900&seq=hero-bg-rose-video&orientation=landscape"
        alt="玫瑰视频 - 高清影视平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <div className="mb-6">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-background-50 text-sm font-medium mb-6">
            全新上线 · 限时免费观影
          </span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          玫瑰视频
          <span className="block text-lg md:text-2xl font-normal mt-3 text-background-50/80">
            高清免费在线观看，不缓冲
          </span>
        </h1>

        <p className="text-base md:text-lg text-background-50/70 mb-10 max-w-2xl mx-auto leading-relaxed">
          聚合红桃视频、樱桃视频、茄子视频、糖心视频等多平台高清资源，
          最新电视剧全集和电影大全一网打尽，追剧观影首选。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/drama"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-full text-base whitespace-nowrap transition-all duration-300 cursor-pointer text-center"
          >
            <i className="ri-play-circle-line mr-2"></i>
            立即观影
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 border-2 border-background-50/30 hover:border-background-50/60 text-background-50 font-medium rounded-full text-base whitespace-nowrap transition-all duration-300 cursor-pointer text-center"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { icon: "ri-movie-line", label: "10万+影片", desc: "海量资源库" },
            { icon: "ri-flashlight-line", label: "极速播放", desc: "不缓冲不卡顿" },
            { icon: "ri-vip-crown-line", label: "完全免费", desc: "无需注册" },
          ].map((item) => (
            <div key={item.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-background-50/15">
                <i className={`${item.icon} text-xl text-background-50`}></i>
              </div>
              <p className="text-background-50 font-semibold text-sm whitespace-nowrap">{item.label}</p>
              <p className="text-background-50/50 text-xs mt-1">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}